// eslint-disable-next-line import/prefer-default-export
export const loans = {
  namespaced: true,
  state: {
    loanTransactionForGroups: [],
    loanPayments: {
      data: [],
      total: 0,
    },
    loanOffers: [],
    loanTransactions: {
      data: [],
      total: 0,
    },
    defaults: [],
    loanGroups: [],
    loanGroupMode: false,
  },
  mutations: {
    updateLoanGroupMode(state, mode) {
      state.loanGroupMode = mode
    },
    setDefaults(state, data) {
      state.defaults = data
    },
    addDefault: (state, defaulted) => {
      state.defaults = [...state.defaults, defaulted]
    },
    updateDefault: (state, defaulted) => {
      state.defaults = state.defaults.map(datum => {
        if (datum.id === defaulted.id) {
          return defaulted
        }
        return datum
      })
    },
    removeDefault: (state, id) => {
      state.defaults = state.defaults.filter(datum => +datum.id !== +id)
    },
    setLoanTransactionForGroups(state, data) {
      state.loanTransactionForGroups = data
    },
    updateLoanGroupTransaction: (state, loanTransaction) => {
      state.loanTransactionForGroups = state.loanTransactionForGroups.map(datum => {
        if (datum.id === loanTransaction.id) {
          return loanTransaction
        }
        return datum
      })
    },
    removeGroupLoan: (state, id) => {
      state.loanTransactionForGroups = state.loanTransactionForGroups.filter(datum => +datum.id !== +id)
    },
    setLoanGroups(state, data) {
      state.loanGroups = data
    },
    addLoanGroup: (state, loanGroup) => {
      state.loanGroups = [...state.loanGroups, loanGroup]
    },
    updateLoanGroup: (state, loanGroup) => {
      state.loanGroups = state.loanGroups.map(datum => {
        if (datum.id === loanGroup.id) {
          return loanGroup
        }
        return datum
      })
    },
    removeLoanGroup: (state, id) => {
      state.loanGroups = state.loanGroups.filter(datum => +datum.id !== +id)
    },
    setLoanOffers(state, data) {
      state.loanOffers = data
    },
    addLoanOffer: (state, loanOffer) => {
      state.loanOffers = [...state.loanOffers, loanOffer]
    },
    updateLoanOffer: (state, loanOffer) => {
      state.loanOffers = state.loanOffers.map(datum => {
        if (datum.id === loanOffer.id) {
          return loanOffer
        }
        return datum
      })
    },
    removeLoanOffer: (state, id) => {
      state.loanOffers = state.loanOffers.filter(datum => +datum.id !== +id)
    },
    setLoanTransactions(state, data) {
      state.loanTransactions = data
    },
    updateCollateralDocuments(state, data) {
      state.loanTransactions = state.loanTransactions.map(datum => {
        if (datum.id === data.id) {
          datum.collateral_documents.splice(data.index, 1)
          return datum
        }
        return datum
      })
    },
    addLoanTransaction: (state, loanTransaction) => {
      state.loanTransactions = { data: [...loanTransaction, ...state.loanTransactions.data], total: state.loanTransactions.total + loanTransaction.length }
    },
    updateLoanTransaction: (state, loanTransaction) => {
      const data = state.loanTransactions.data.map(datum => {
        if (datum.id === loanTransaction.id) {
          return loanTransaction
        }
        return datum
      })
      state.loanTransactions = { ...state.loanTransactions, data }
    },
    removeLoanTransaction: (state, id) => {
      state.loanTransactions = state.loanTransactions.filter(datum => +datum.id !== +id)
    },
    setLoanPayments(state, data) {
      state.loanPayments = data
    },
    addLoanPayment: (state, loanPayment) => {
      state.loanPayments = { data: [loanPayment, ...state.loanPayments.data], total: state.loanPayments.total + 1 }
    },
    reverseLoanPayment: (state, loanPayment) => {
      const data = state.loanPayments.data.map(pay => {
        if (pay.id === loanPayment) {
          return { ...pay, reversed: true }
        }
        return pay
      })
      state.loanPayments = { data, total: state.loanPayments.total }
    },
  },
  getters: {
    loanGroupMode(state) {
      return state.loanGroupMode
    },
    loanOffers(state) {
      return state.loanOffers
    },
    loanPayments(state) {
      return state.loanPayments.data
    },
    totalPaymentsData(state) {
      return state.loanPayments.total
    },
    loanTransactionForGroups(state) {
      return state.loanTransactionForGroups.map(m => ({
        ...m,
        collateral_documents: m.collateral_documents ? m.collateral_documents instanceof Array ? m.collateral_documents : JSON.parse(m.collateral_documents) : null,
      }))
    },
    loanTransactions(state) {
      return state.loanTransactions.data.map(m => ({
        ...m,
        title: `${m.customer} - ${m.reference}`,
        collateral_documents: m.collateral_documents ? m.collateral_documents instanceof Array ? m.collateral_documents : JSON.parse(m.collateral_documents) : null,
      }))
    },
    totalData(state) {
      return state.loanTransactions.total
    },
    defaults(state) {
      return state.defaults
    },
    loanGroups(state) {
      return state.loanGroups
    },
  },
}
